import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";
import type { CourseLevel, CreateCourseLevelData, UpdateCourseLevelData } from "./types";

export * from "./types";

/** Kurs darajalari API — backend'dagi `CourseLevelsController` ning ko'zgusi. */
export class CourseLevelsApi extends BaseApi {
  private readonly baseUrl: string = "/course-levels";

  getAll() {
    return this.request.get<CourseLevel[], ApiResponse<CourseLevel[]>>(this.baseUrl);
  }

  create(data: CreateCourseLevelData) {
    return this.request.post<CourseLevel, ApiResponse<CourseLevel>>(this.baseUrl, data);
  }

  update(id: number, data: UpdateCourseLevelData) {
    return this.request.patch<CourseLevel, ApiResponse<CourseLevel>>(`${this.baseUrl}/${id}`, data);
  }

  remove(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }
}

export const courseLevelsApi = new CourseLevelsApi();
